(() => {
  const config = document.querySelector('script[data-sa-collection-preference]');
  if (!config || window.SACollectionPageSize) return;

  const key = 'sa_collection_page_size';
  const choices = ['15', '30', '60', 'all'];
  const views = ['sa-page-size-30', 'sa-page-size-60', 'sa-page-size-all'];
  const valid = value => choices.includes(value);
  const read = () => {
    try {
      const value = localStorage.getItem(key);
      return valid(value) ? value : null;
    } catch {
      return null;
    }
  };
  const save = choice => {
    if (!valid(choice)) return;
    try { localStorage.setItem(key, choice); } catch { /* URL still applies this choice when storage is unavailable. */ }
  };
  const urlFor = choice => {
    const url = new URL(location.href);
    if (choice === '15') url.searchParams.delete('view');
    else if (valid(choice)) url.searchParams.set('view', 'sa-page-size-' + choice);
    return url;
  };
  window.SACollectionPageSize = { read, save, urlFor };

  const legacy = config.dataset.legacyChoice;
  if (legacy) {
    if (!read() && valid(legacy)) save(legacy);
    // Delete only the obsolete preference; leave products and other cart attributes intact.
    fetch(config.dataset.cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [key]: '' } }),
      keepalive: true
    }).catch(() => { /* Retry on the next page if the visitor is offline. */ });

    // Standard cart checkout also clears the attribute when its form is submitted.
    document.querySelectorAll('form[action$="/cart"]').forEach(form => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + key + ']';
      input.value = '';
      form.appendChild(input);
    });
  }

  if (config.dataset.collectionPage !== 'true' || window.Shopify?.designMode) return;
  const url = new URL(location.href);
  const view = url.searchParams.get('view');
  if (views.includes(view)) {
    save(view.slice('sa-page-size-'.length));
    return;
  }
  // Other alternate views, including the SKU index, must keep their own behavior.
  if (view) return;
  const choice = read();
  if (!choice || choice === '15') return;
  const target = urlFor(choice);
  target.searchParams.delete('page');
  target.searchParams.delete('section_id');
  location.replace(target.href);
})();
